import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const CustomFieldsIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M5 4.75H14.5C15.6046 4.75 16.5 5.64543 16.5 6.75V17.25C16.5 18.3546 15.6046 19.25 14.5 19.25H5C3.89543 19.25 3 18.3546 3 17.25V6.75C3 5.64543 3.89543 4.75 5 4.75Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.75 8.25H12.75M6.75 12H10.75M6.75 15.75H12.75"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
      <path
        d="M18.75 3.75V7.25M17 5.5H20.5"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
      <path
        d="M19.25 14.25V20.25M16.25 17.25H22.25"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </BaseIcon>
  );
};

CustomFieldsIcon.displayName = 'CustomFieldsIcon';
